import React from "react";
import { Helmet } from "react-helmet-async";

const SEOOptimization = ({ 
  title = "JyotixEdge | AI Automation & Enterprise Intelligence",
  description = "JyotixEdge — AI-driven automation, forecasting and business intelligence for enterprises and hospitality.",
  keywords = "AI automation, enterprise forecasting, restaurant intelligence, business intelligence, JyotixEdge",
  canonical = "https://www.jyotixedge.com/",
  schema = null 
}) => {
  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "JyotixEdge Pvt. Ltd.",
    "url": "https://www.jyotixedge.com",
    "logo": "https://www.jyotixedge.com/icons/apple-touch-icon.png",
    "description": description,
    "foundingDate": "2023",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "sales",
      "email": "info@jyotixedge.com",
      "availableLanguage": "English"
    },
    "areaServed": ["India", "United States", "United Kingdom", "UAE", "Singapore"],
    "serviceType": "Enterprise AI Solutions",
    "knowsAbout": [
      "Artificial Intelligence",
      "Machine Learning",
      "Business Intelligence",
      "Enterprise Automation",
      "Predictive Analytics",
      "Restaurant Technology",
      "Supply Chain Optimization"
    ]
  };

  return (
    <Helmet>
      {/* Enhanced SEO Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="language" content="English" />
      <meta name="author" content="JyotixEdge Pvt. Ltd." />
      <meta name="publisher" content="JyotixEdge Pvt. Ltd." />
      <meta name="copyright" content="JyotixEdge Pvt. Ltd." />
      <meta name="rating" content="General" />
      <meta name="distribution" content="Global" />
      
      {/* Geographic Targeting */}
      <meta name="geo.region" content="IN" />
      <meta name="geo.placename" content="India" />
      <meta name="ICBM" content="28.6139, 77.2090" />
      
      {/* Open Graph Enhanced */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="JyotixEdge" />
      <meta property="og:image" content="https://www.jyotixedge.com/icons/meta-preview.png" />
      <meta property="og:image:alt" content="JyotixEdge AI Platform Dashboard" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card Enhanced */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://www.jyotixedge.com/icons/meta-preview.png" />
      <meta name="twitter:site" content="@JyotixEdge" />
      <meta name="twitter:creator" content="@JyotixEdge" />
      
      {/* Enhanced Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(schema || defaultSchema)}
      </script>
    </Helmet>
  );
};

export default SEOOptimization;